import { Button } from '@material-ui/core'
import BigNumber from 'bignumber.js'
import React from 'react'
import useStyles from "./depositeStyles";

function DepositeButton({value, mContentBalance, pendingTransaction, depositTokens, invalidReceiving }) {
    const classes = useStyles();
    return (
        <Button
        disableRipple
        className={`${
          new BigNumber(parseFloat(value)).valueOf().length > 0&&value.length == 0 ?classes.emptyAmount:(
          new BigNumber(parseFloat(value)).isLessThanOrEqualTo(
            parseFloat(mContentBalance)
          ) && value != 0 
            ?invalidReceiving?classes.errorButton:( /^[0-9]*(?:\.[0-9]{0,6})?$/.test(
                value ? new BigNumber(value) : ""
              )
              ? classes.normalButton
              : classes.errorButton
          ): (classes.errorButton))
        } ${classes.depositeButton}`}
        disabled={
          value.length == 0 ||
          value == 0 ||
          pendingTransaction ||
          new BigNumber(parseFloat(value)).gt(
            parseFloat(mContentBalance)
          ) ||
          !/^[0-9]*(?:\.[0-9]{0,6})?$/.test(
            value ? new BigNumber(value) : ""
          )
        }
        fullWidth
        onClick={depositTokens}
      >
        {new BigNumber(value).valueOf().length > 0 &&
        new BigNumber(parseFloat(value)).isLessThanOrEqualTo(
          parseFloat(mContentBalance)
        )
          ?value==0?"Enter an Amount":invalidReceiving?"Invalid Address": "Create Crosschain Asset"
          : new BigNumber(parseFloat(value)).gt(
              parseFloat(mContentBalance)
            )
          ? "Insufficient funds"
          : "Enter an Amount"}
      </Button>
    )
}

export default DepositeButton
